import { PencilIcon, PlusCircleIcon, TrashIcon } from '@heroicons/react/24/solid';
import React, { useEffect, useState } from 'react';
import { deleteAddOn, getAddOnList } from '../../../api/AddOnInteractor';
import { showToast } from '../../../Utils';

function ListAddon(props) {

  let [addOnList, setAddOnList] = useState([])

  const getAddOnListApi = () => {
    getAddOnList(
      //success
      (responseJSON) => {
        setAddOnList(responseJSON)
      },
      //failed
      (message) => {
        showToast("Error", "Create Failed", message)
      }
    )
  }

  useEffect(() => {
    getAddOnListApi()
  }, [])

  const deleteAddOnApi = (addOnId) => {
    if (window.confirm("Are you sure?")) {
      deleteAddOn(addOnId,
        //success
        (responseJSON) => {
          showToast("Success", "Delete Success", "Add On deleted successfully")
          getAddOnListApi()
        },
        //failed
        (message) => {
          showToast("Error", "Delete Failed", message)
        }
      )
    }
  }

  const renderAddon = () => {
    return addOnList.map((item) => {
      return (
        <div className='flex gap-x-6 px-6 py-4 border border-gray-300 rounded-lg'>
          <img src={process.env.REACT_APP_BASE_URL_IMAGE + item.image.url} className='w-[75px] h-fit' />
          <div className='flex flex-col flex-grow' >
            <p className='text-sm text-left text-gray-800 font-semibold'>{item.name}</p>

            <div className='flex flex-col w-full lg:flex-row gap-y-3 lg:gap-x-6  mt-4' >

              <div className='w-1/4'>
                <p className='text-xs text-left block text-gray-800 lg:mb-4 w-full'>Harga Satuan</p>
                <p className='text-[10px] inline text-left text-gray-800 mr-6'>{item.price}</p>
                <span className='text-[12px] text-left text-gray-800'>/ {item.unit}</span>
              </div>

              <div className='w-1/2 flex-grow  '>
                <p className='text-xs text-left block text-gray-800 lg:mb-4 w-full'>Keterangan</p>
                <p className='text-[10px] inline text-left text-gray-800 mr-6'>{item.note}</p>
              </div>

              <div className='w-1/4 flex flex-col justify-end items-end gap-2'>

                <a href={'/addon/edit/' + item.id}>
                  <button className='flex items-center text-xs  px-4 py-1.5 border border-primaryRed rounded-md text-primaryRed'>
                    <img src='/ic-pen.svg' className='w-5 mr-1' />
                    Edit
                  </button>
                </a>


                <button onClick={() => { deleteAddOnApi(item.id) }} className='flex items-center text-xs px-4 py-2 border border-primaryRed rounded-md text-primaryRed'>
                  <TrashIcon className='w-4 mr-2' />
                  Hapus
                </button>

              </div>

            </div>

          </div>
        </div>
      )
    })
  }

  return (
    <div className="w-full h-full bg-white rounded-2xl flex flex-col px-6 py-6">
      {/* Header Section */}
      <div className="flex items-center justify-between mt-4">
        <p className="text-lg font-semibold text-gray-800">Add On</p>

        <a href="/addon/create">
          <button className="flex items-center px-6 py-2 text-xs text-white bg-primaryRed rounded-md">
            <PlusCircleIcon className="w-5 h-5 mr-2" />
            Buat Add On Baru
          </button>
        </a>
      </div>

      {/* Content Section */}
      <div className="flex flex-col flex-1 mt-8 gap-y-4 w-full">
        {addOnList.length > 0 ? (
          renderAddon()
        ) : (
            <div className="flex flex-1 flex-col items-center justify-center w-full border border-gray-200 rounded-lg overflow-hidden text-center px-4 py-6 text-sm text-gray-600">
              <img src="/il-empty-noaddon.png" alt="Empty State" className="w-[260px] mb-4" />
              <span className='text-[#898989] text-lg font-semibold mb-4'>Add On</span>
              <span className='text-[#898989]'>
                Tidak ada data yang ditampilkan karena belum ada Add On dibuat,<br></br>
                silahkan buat Add On baru dengan klik tombol di atas.
              </span>
            </div>

        )}
      </div>
    </div>

  );
}

export default ListAddon